import React from 'react';
import { shape, string } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from '../../components/Loading';

const PrivateRoute = ({
  // eslint-disable-next-line react/prop-types
  component: Component,
  scrollableDiv,
  _superPrivate,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={props => {
        if (isAuthenticated) {
          // For now, skip superPrivate check since we don't have user roles from Auth0 yet
          return <Component scrollableDiv={scrollableDiv} {...props} />; // eslint-disable-line react/jsx-props-no-spreading
        }

        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.defaultProps = {
  scrollableDiv: {},
  location: {},
  _superPrivate: '',
};

PrivateRoute.propTypes = {
  scrollableDiv: shape({}),
  location: shape({}),
  _superPrivate: string,
};

export default PrivateRoute;
